/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalAttachmentViewModel } from "../types/PersonDocumentApprovalAttachmentViewModel.ts";
import { personDocumentApprovalOcrDataViewModelSchema } from "./personDocumentApprovalOcrDataViewModelSchema.ts";

export const personDocumentApprovalAttachmentViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do anexo.")),
  path: z.string().describe("Caminho do arquivo no storage.").nullish(),
  url: z
    .string()
    .describe(
      "URL SAS do arquivo para exibição inline no front; nula quando não há arquivo. Opcional.",
    )
    .nullish(),
  description: z.string().describe("Descrição do anexo. Opcional.").nullish(),
  date: z
    .string()
    .datetime()
    .describe("Data da última alteração do anexo. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o anexo está ativo.")),
  fileType: z
    .number()
    .int()
    .describe(
      "Tipo do arquivo: 1 = documento de empresa associada; nulo = anexo comum de matrícula. Opcional.",
    )
    .nullish(),
  hasCourseIRI: z.optional(
    z.boolean().describe("Indica se o anexo pertence a curso IRI."),
  ),
  enrollmentDocumentId: z
    .number()
    .int()
    .describe("ID do documento de matrícula (tipo) do anexo. Opcional.")
    .nullish(),
  documentationStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status do anexo. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
      ),
  ),
  isPdf: z.optional(
    z.boolean().describe("Indica se o arquivo é PDF (senão, imagem)."),
  ),
  ocrData: z.optional(
    z.lazy(() => personDocumentApprovalOcrDataViewModelSchema),
  ),
}) as unknown as ToZod<PersonDocumentApprovalAttachmentViewModel>;
